export const chartTooltipMap = {
    // Português
    "Ranking de Motoristas": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Maior Circulação": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Maior Ociosidade": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Fora do Horário Comercial": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Circulação Semanal": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Limite de Velocidade": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Multas de Trânsito": "DASHBOARD_CHARTS_TRANSIT_FINES",
    "Status dos Veículos": "DASHBOARD_CHARTS_VEHICLE_STATUS",
    
    // English
    "Driver Ranking": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Highest Circulation": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Highest Idleness": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Outside Work Hours": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Weekly Circulation": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Speed Limit": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Traffic Fines": "DASHBOARD_CHARTS_TRANSIT_FINES",
    "Vehicle Status": "DASHBOARD_CHARTS_VEHICLE_STATUS",
    
    // Español
    "Clasificación de Conductores": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Mayor Circulación": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Mayor Inactividad": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Fuera del Horario Laboral": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Circulación Semanal": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Límite de Velocidad": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Comparendos de Tránsito": "DASHBOARD_CHARTS_TRANSIT_FINES",
    "Estado de los Vehículos": "DASHBOARD_CHARTS_VEHICLE_STATUS",
  };
  
  /**
   * Obtém a chave de tooltip baseada no nome do gráfico
   * @param {string} chartName - Nome do gráfico (opt.chart traduzido)
   * @returns {string} - Chave do tooltip ou vazio se não encontrar
   */
  export const getTooltipKeyByChart = (chartName) => {
    return chartTooltipMap[chartName] || "";
  };
  